module.exports = __webpack_public_path__ + "media/images/secure-2741eac4912487f6b9dc948a27573f6f.jpg";